export default "/_next/static/media/video.355f822c.mp4";